module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-basic-307048b4b0dd07a9f4ac1b4904497677.png";